import React, { useState } from "react";
import {
  TabsProvider,
  TabsContext,
} from "../../../ReusableComponents/TabsQBAdmin";
import English from "./English";
import InternetChecking from "../../../Student/Reusablecomponents/Network";
import CopyRight from "../../../Student/Reusablecomponents/Copyright";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { TabViewValues } from "../../../ReusableComponents/CommonFunctions";
import { useSelector } from "react-redux";
const EnglishQB = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [LoFilters, SetLoFilters] = useState(
    JSON.parse(localStorage.getItem("LoFilters")) || false
  );
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const Tabs = [
    { Name: "Scenario based Questions", Value: "SCQ" },
    { Name: "Direct Questions", Value: "DQ" },
    { Name: "Input based Questions", Value: "INQ" },
  ];

  const StoreFilters = (FState) => {
    localStorage.setItem("LoFilters", FState);
    localStorage.removeItem("FSelected");
    localStorage.removeItem("EngFType");
    SetLoFilters(FState);
    if (FState) {
      navigate(`/QBAdmin/QuestionBank/EnglishFilter`, {
        state: { Tab: "SCQ" },
      });
    } else {
      navigate(`/QBAdmin/QuestionBank`, { state: { Tab: "SCQ" } });
    }
  };
  const ChangeTab = (e) => {
    if (LoFilters) {
      navigate(`/QBAdmin/QuestionBank/EnglishFilter`, { state: { Tab: e } });
    } else {
      switch (e) {
        case "SCQ":
          navigate(`/QBAdmin/QuestionBank`, { state: { Tab: e } });
          break;
        case "DQ":
          return navigate(`/QBAdmin/QuestionBank/DirectQuestions`, {
            state: { Tab: e },
          });
        case "INQ":
          return navigate(`/QBAdmin/QuestionBank/InputBasedQuestions`, {
            state: { Tab: e },
          });
      }
    }
  };
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="dflex JCCenter" style={{ gap: "15px" }}>
          {[false, true].map((Item) => (
            <div className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="Radio"
                name="Lo"
                checked={Item === LoFilters}
                value={Item}
                onChange={() => StoreFilters(!LoFilters)}
              />
              <b>{Item ? "Apply filters to QB" : "Question Bank"}</b>
            </div>
          ))}
        </div>

        <TabViewValues
          Tabs={Tabs}
          Selectedtab={location.state?.Tab || "SCQ"}
          onClick={(e) => {
            ChangeTab(e);
          }}
        />
        {LoFilters && !location.pathname.includes("/EnglishFilter") && (
          <div className="dflex alignitems mt-2 mb-2">
            English &gt; {FQuestionDetails?.level1Name}{" "}
            {!FQuestionDetails?.grammarName && "> "}{" "}
            {FQuestionDetails?.level2Name}{" "}
            {!FQuestionDetails?.grammarName && "> "}{" "}
            <b className="text-success">
              {FQuestionDetails?.level3Name || FQuestionDetails?.grammarName}
            </b>
          </div>
        )}
        <Outlet />
        {/* <CopyRight /> */}
      </div>
    </>
  );
};
export default EnglishQB;
